import { render } from "./updateHarbour.vue?vue&type=template&id=374ca06e&scoped=true"
import script from "./updateHarbour.vue?vue&type=script&lang=js"
export * from "./updateHarbour.vue?vue&type=script&lang=js"

import "./updateHarbour.vue?vue&type=style&index=0&id=374ca06e&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374ca06e"]])

export default __exports__